module.exports = __webpack_public_path__ + "img/search.3a4044d0.svg";